export const config = {
  pageSize: 25,
}
